import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Dialog,
  Typography,
} from "@mui/material";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { useDialogAPI } from "../dialogs/context/DialogProvider";
import { usePopUpsAPI, usePopUpsData } from "./context/PopUpsProvider";

export const PopUpsModule = () => {
  console.info("PopUpsModule render");

  //  OTHER CONTEXTS
  const { t } = useTranslation();
  const { current, isOpen } = usePopUpsData();
  const { closePopUp } = usePopUpsAPI();
  const { nextDialog } = useDialogAPI();

  //  HANDLES
  const HandleClose = () => {
    closePopUp();
    nextDialog();
  };

  return (
    <Dialog open={isOpen} fullWidth onClose={HandleClose}>
      <Card
        sx={{ maxWidth: "100%", overflow: "auto", scrollbarWidth: "0.1em" }}
      >
        <CardMedia
          component="img"
          image={`./img/popups/${current}.png`}
          sx={{ objectFit: "contain", w: "80%" }}
        />
        <CardContent>
          <Typography sx={{}}>{parse(t(`dialogs.${current}`))}</Typography>
          <CardActions>
            <Button onClick={HandleClose}>{t("ui.button.close")}</Button>
          </CardActions>
        </CardContent>
      </Card>
    </Dialog>
  );
};
